// extracted by mini-css-extract-plugin
export default {"container":"XCK9Pe","initials":"IV3YxD","initialsMask":"NgMomN","content":"Wj1GT1","name":"dnPk3p","link":"haFBVQ","comment":"g3BR69","accessibilityThemeReadMore":"ULumZg"};